import { Fragment as e, computed as t, createBlock as n, createElementBlock as r, defineComponent as i, mergeProps as a, normalizeStyle as o, openBlock as s, ref as c, renderList as l, unref as u, withCtx as d } from "vue";
import { registerEntityEndpoint as f } from "@editor/ui-utils";
import { QCarousel as p, QCarouselSlide as m, QImg as h, useQuasar as g } from "quasar";
import { getImageUrl as _ } from "@modules/image-editor-ui-components";
//#region src/services/gallery.service.ts
var v = "Galleries", y = f(v), { getEntity: b, listEntities: x, putEntity: S, postEntity: C, deleteEntity: w } = y, T = async (e, t = {}) => x({ params: {
	search: e,
	...t
} }), E = async (e) => b(e), D = async (e) => C({
	...e,
	references: e.references?.filter((e) => e.uuid)
}), O = async (e, t) => S(t, {
	...e,
	references: e.references?.filter((e) => e.uuid)
}), k = async (e) => w(e), A = () => ({
	type: "GALLERY",
	galleryUuid: "",
	inlineRendered: !1,
	galleryStartOffset: void 0,
	galleryEndOffset: void 0
}), j = /* @__PURE__ */ i({
	__name: "gallery-preview-carousel",
	props: {
		references: {},
		previewCount: { default: 4 },
		previewSize: {},
		previewOffset: { default: 0 },
		previewLimit: { default: void 0 }
	},
	emits: ["update:previewCount"],
	setup(i, { emit: f }) {
		let v = g();
		v.screen.setSizes({
			sm: 320,
			md: 768,
			lg: 1024,
			xl: 1400
		});
		let y = f, b = i, x = c(0), S = t({
			get() {
				return v.screen.sm || v.screen.md ? 2 : v.screen.lg ? 3 : b.previewCount;
			},
			set(e) {
				y("update:previewCount", e);
			}
		}), C = t(() => Math.max(0, Math.min(b.previewOffset, b.references.length - 1))), w = t(() => Math.max(C.value + 1, Math.min(b.previewLimit ?? b.references.length, b.references.length))), T = t(() => b.references.slice(C.value, w.value).reduce((e, t, n) => (n % S.value == 0 ? e.push([t]) : e[e.length - 1].push(t)) && e, []));
		return (t, c) => (s(), n(u(p), a(b, {
			modelValue: x.value,
			"onUpdate:modelValue": c[0] ||= (e) => x.value = e,
			height: `${b.previewSize.height}px`,
			style: { width: "auto" },
			class: "gallery-carousel"
		}), {
			default: d(() => [(s(!0), r(e, null, l(T.value, (t, a) => (s(), n(u(m), {
				key: a,
				class: "q-pa-none gallery-carousel__slide",
				name: a
			}, {
				default: d(() => [(s(!0), r(e, null, l(t, (e) => (s(), n(u(h), {
					key: e.uuid,
					src: u(_)(e.uuid, b.previewSize.width, b.previewSize.height),
					style: o({
						width: i.previewSize.width + "px",
						height: i.previewSize.height + "px"
					})
				}, null, 8, ["src", "style"]))), 128))]),
				_: 2
			}, 1032, ["name"]))), 128))]),
			_: 1
		}, 16, ["modelValue", "height"]));
	}
}), M = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
}, N = /* @__PURE__ */ M(j, [["__scopeId", "data-v-1881ec44"]]);
//#endregion
export { k as a, T as c, y as i, E as l, M as n, O as o, v as r, A as s, N as t, D as u };

//# sourceMappingURL=gallery-preview-carousel-DivlId6s.js.map